// src/sagas/documentSubmissionSaga.js
// Handles presigned URL request for fipsr-document-submissions bucket.
// Calls the doc-intake-s3-document-trigger Lambda Function URL directly —
// the Library Card Lambda doesn't have IAM permission on fipsr-document-submissions,
// so we bypass AppSync entirely and use a dedicated endpoint on the doc-intake Lambda
// which was CDK-granted PutObject access to the bucket.
import { takeEvery, call, put } from "redux-saga/effects";
import {
  REQUEST_DOCUMENT_SUBMISSION_PRESIGNED_URL,
  requestDocumentSubmissionPresignedUrlSuccess,
  requestDocumentSubmissionPresignedUrlFailure,
} from "../actions/documentSubmissionActions";

const DOC_INTAKE_PRESIGNED_URL_ENDPOINT =
  "https://iw9w7nymx6.execute-api.us-east-1.amazonaws.com/";

async function fetchDocIntakePresignedUrl({ tenantId, fileName, documentId }) {
  const response = await fetch(DOC_INTAKE_PRESIGNED_URL_ENDPOINT, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ tenantId, fileName, documentId }),
  });
  if (!response.ok) {
    const text = await response.text();
    throw new Error(`Presigned URL request failed (${response.status}): ${text}`);
  }
  const data = await response.json();
  return data.presignedUrl;
}

function* requestPresignedUrlSaga(action) {
  const { tenantId, fileName, documentId } = action.payload;

  try {
    console.log("DocumentSubmissionSaga - Requesting presigned URL via doc-intake Lambda:", {
      tenantId,
      fileName,
      documentId,
    });

    const presignedUrl = yield call(fetchDocIntakePresignedUrl, { tenantId, fileName, documentId });

    console.log("DocumentSubmissionSaga - Presigned URL received");
    yield put(requestDocumentSubmissionPresignedUrlSuccess(presignedUrl));
  } catch (error) {
    console.error("DocumentSubmissionSaga - Error requesting presigned URL:", error.message);
    yield put(requestDocumentSubmissionPresignedUrlFailure(error.message || "Failed to get presigned URL"));
  }
}

export default function* documentSubmissionSaga() {
  yield takeEvery(REQUEST_DOCUMENT_SUBMISSION_PRESIGNED_URL, requestPresignedUrlSaga);
}
